{
 "note": "made by tools/make-sprites.py from assets/models; do not edit",
 "image": "/sprites/atlas.png",
 "ppm": 24,
 "k": 0.6,
 "light": [
  -0.4581,
  0.8653,
  0.2036
 ],
 "sprites": {
  "tree1": {
   "x": 0,
   "y": 0,
   "w": 110,
   "h": 106,
   "ax": 30.3,
   "ay": 86.3,
   "r": 1.18
  },
  "tree2": {
   "x": 112,
   "y": 0,
   "w": 103,
   "h": 120,
   "ax": 29.2,
   "ay": 100.6,
   "r": 1.91
  },
  "tree3": {
   "x": 217,
   "y": 0,
   "w": 98,
   "h": 88,
   "ax": 24.8,
   "ay": 74.4,
   "r": 1.13
  },
  "tree4": {
   "x": 317,
   "y": 0,
   "w": 147,
   "h": 110,
   "ax": 49.2,
   "ay": 94.7,
   "r": 2.02
  },
  "bush1": {
   "x": 466,
   "y": 0,
   "w": 42,
   "h": 44,
   "ax": 18.5,
   "ay": 25.2,
   "r": 0.76
  },
  "bush2": {
   "x": 510,
   "y": 0,
   "w": 45,
   "h": 50,
   "ax": 18.5,
   "ay": 30.3,
   "r": 0.8
  },
  "bush3": {
   "x": 557,
   "y": 0,
   "w": 67,
   "h": 50,
   "ax": 28.1,
   "ay": 28.0,
   "r": 1.33
  },
  "traffic_light1": {
   "x": 626,
   "y": 0,
   "w": 96,
   "h": 106,
   "ax": 16.5,
   "ay": 88.6,
   "r": 0.23,
   "ppm": 64
  },
  "stair_hut": {
   "x": 724,
   "y": 0,
   "w": 130,
   "h": 151,
   "ax": 51.2,
   "ay": 98.4,
   "r": 2.59
  },
  "skylight": {
   "x": 856,
   "y": 0,
   "w": 116,
   "h": 146,
   "ax": 52.0,
   "ay": 79.0,
   "r": 3.42
  },
  "water_tank": {
   "x": 974,
   "y": 0,
   "w": 55,
   "h": 57,
   "ax": 20.0,
   "ay": 36.5,
   "r": 1.06
  },
  "ac_unit": {
   "x": 1031,
   "y": 0,
   "w": 34,
   "h": 22,
   "ax": 12.8,
   "ay": 15.7,
   "r": 0.48
  },
  "chai_stall": {
   "x": 1067,
   "y": 0,
   "w": 94,
   "h": 70,
   "ax": 32.0,
   "ay": 54.6,
   "r": 1.48
  },
  "fruit_cart": {
   "x": 1163,
   "y": 0,
   "w": 88,
   "h": 78,
   "ax": 28.4,
   "ay": 62.3,
   "r": 1.1
  },
  "flower_stall": {
   "x": 1253,
   "y": 0,
   "w": 93,
   "h": 69,
   "ax": 32.0,
   "ay": 53.2,
   "r": 1.48
  },
  "book_stall": {
   "x": 1348,
   "y": 0,
   "w": 96,
   "h": 70,
   "ax": 34.4,
   "ay": 52.9,
   "r": 1.6
  },
  "snack_cart": {
   "x": 1446,
   "y": 0,
   "w": 89,
   "h": 77,
   "ax": 23.6,
   "ay": 61.1,
   "r": 1.35
  },
  "metro_gate_open": {
   "x": 1537,
   "y": 0,
   "w": 167,
   "h": 225,
   "ax": 62.5,
   "ay": 138.0,
   "r": 4.59
  },
  "metro_gate_shut": {
   "x": 1706,
   "y": 0,
   "w": 167,
   "h": 225,
   "ax": 62.5,
   "ay": 138.0,
   "r": 4.59
  },
  "police_booth": {
   "x": 1875,
   "y": 0,
   "w": 81,
   "h": 80,
   "ax": 24.8,
   "ay": 60.1,
   "r": 1.34
  },
  "cctv_pole": {
   "x": 0,
   "y": 227,
   "w": 203,
   "h": 184,
   "ax": 7.8,
   "ay": 177.7,
   "r": 1.06,
   "ppm": 48
  },
  "first_aid_box": {
   "x": 205,
   "y": 227,
   "w": 52,
   "h": 42,
   "ax": 19.9,
   "ay": 28.2,
   "r": 0.33,
   "ppm": 64
  },
  "candles": {
   "x": 259,
   "y": 227,
   "w": 51,
   "h": 41,
   "ax": 24.4,
   "ay": 22.4,
   "r": 0.43,
   "ppm": 64
  },
  "dhol": {
   "x": 312,
   "y": 227,
   "w": 59,
   "h": 37,
   "ax": 22.6,
   "ay": 24.4,
   "r": 0.37,
   "ppm": 64
  },
  "megaphone": {
   "x": 373,
   "y": 227,
   "w": 35,
   "h": 35,
   "ax": 22.8,
   "ay": 10.4,
   "r": 0.38,
   "ppm": 64
  },
  "barricade_chain": {
   "x": 410,
   "y": 227,
   "w": 177,
   "h": 26,
   "ax": 76.4,
   "ay": 29.3,
   "r": 1.55,
   "ppm": 48
  },
  "surveillance_van": {
   "x": 589,
   "y": 227,
   "w": 104,
   "h": 153,
   "ax": 25.4,
   "ay": 109.6,
   "r": 1.9
  },
  "auto_rickshaw": {
   "x": 695,
   "y": 227,
   "w": 59,
   "h": 87,
   "ax": 18.1,
   "ay": 50.8,
   "r": 1.51
  },
  "auto_rickshaw_black": {
   "x": 756,
   "y": 227,
   "w": 59,
   "h": 87,
   "ax": 18.1,
   "ay": 50.8,
   "r": 1.51
  },
  "oga-concert-props/barricade@0": {
   "x": 817,
   "y": 227,
   "w": 73,
   "h": 29,
   "ax": 30.4,
   "ay": 18.4,
   "r": 1.22
  },
  "oga-concert-props/barricade@45": {
   "x": 892,
   "y": 227,
   "w": 62,
   "h": 64,
   "ax": 27.4,
   "ay": 36.4,
   "r": 1.22
  },
  "oga-concert-props/barricade@90": {
   "x": 956,
   "y": 227,
   "w": 27,
   "h": 75,
   "ax": 9.8,
   "ay": 44.2,
   "r": 1.22
  },
  "oga-concert-props/barricade@135": {
   "x": 985,
   "y": 227,
   "w": 62,
   "h": 64,
   "ax": 27.4,
   "ay": 36.3,
   "r": 1.22
  },
  "kenney-retro-urban-kit/detail-barrier-type-a@0": {
   "x": 1049,
   "y": 227,
   "w": 43,
   "h": 24,
   "ax": 15.0,
   "ay": 17.9,
   "r": 0.57
  },
  "kenney-retro-urban-kit/detail-barrier-type-a@45": {
   "x": 1094,
   "y": 227,
   "w": 39,
   "h": 41,
   "ax": 14.0,
   "ay": 26.6,
   "r": 0.57
  },
  "kenney-retro-urban-kit/detail-barrier-type-a@90": {
   "x": 1135,
   "y": 227,
   "w": 23,
   "h": 45,
   "ax": 6.0,
   "ay": 29.4,
   "r": 0.57
  },
  "kenney-retro-urban-kit/detail-barrier-type-a@135": {
   "x": 1160,
   "y": 227,
   "w": 39,
   "h": 41,
   "ax": 14.0,
   "ay": 26.6,
   "r": 0.57
  },
  "kenney-city-kit-roads/construction-barrier@0": {
   "x": 1201,
   "y": 227,
   "w": 35,
   "h": 59,
   "ax": 14.2,
   "ay": 36.3,
   "r": 0.95
  },
  "kenney-city-kit-roads/construction-barrier@45": {
   "x": 1238,
   "y": 227,
   "w": 55,
   "h": 57,
   "ax": 23.7,
   "ay": 32.9,
   "r": 0.95
  },
  "kenney-city-kit-roads/construction-barrier@90": {
   "x": 1295,
   "y": 227,
   "w": 57,
   "h": 36,
   "ax": 22.2,
   "ay": 21.5,
   "r": 0.95
  },
  "kenney-city-kit-roads/construction-barrier@135": {
   "x": 1354,
   "y": 227,
   "w": 55,
   "h": 57,
   "ax": 23.7,
   "ay": 32.9,
   "r": 0.95
  },
  "quaternius-public-transport/Bus@0": {
   "x": 1411,
   "y": 227,
   "w": 284,
   "h": 156,
   "ax": 47.8,
   "ay": 67.0,
   "r": 9.34
  },
  "oga-concert-props/stage-005~805A3A": {
   "x": 1697,
   "y": 227,
   "w": 212,
   "h": 136,
   "ax": 101.8,
   "ay": 71.8,
   "r": 4.88
  },
  "oga-concert-props/speaker-004": {
   "x": 1911,
   "y": 227,
   "w": 46,
   "h": 41,
   "ax": 14.4,
   "ay": 30.1,
   "r": 0.63
  },
  "oga-concert-props/speaker-005": {
   "x": 1959,
   "y": 227,
   "w": 57,
   "h": 54,
   "ax": 13.4,
   "ay": 43.7,
   "r": 0.57
  },
  "oga-concert-props/mic-001": {
   "x": 2018,
   "y": 227,
   "w": 24,
   "h": 29,
   "ax": 4.4,
   "ay": 23.2,
   "r": 0.16
  },
  "oga-concert-props/speaker-001": {
   "x": 0,
   "y": 413,
   "w": 26,
   "h": 27,
   "ax": 7.5,
   "ay": 18.8,
   "r": 0.32
  },
  "kenney-fantasy-town-kit/banner-red~F1ECE0": {
   "x": 28,
   "y": 413,
   "w": 46,
   "h": 75,
   "ax": -25.0,
   "ay": 62.7,
   "r": 1.45
  },
  "kenney-furniture-kit/rugRectangle~2F5D8C": {
   "x": 76,
   "y": 413,
   "w": 73,
   "h": 45,
   "ax": 69.8,
   "ay": 2.3,
   "r": 3.28
  },
  "kenney-furniture-kit/rugRounded~8C3B2F": {
   "x": 151,
   "y": 413,
   "w": 73,
   "h": 45,
   "ax": 69.8,
   "ay": 2.3,
   "r": 2.99
  },
  "kenney-furniture-kit/table": {
   "x": 226,
   "y": 413,
   "w": 48,
   "h": 32,
   "ax": 38.4,
   "ay": 10.5,
   "r": 1.72
  },
  "kenney-furniture-kit/chair": {
   "x": 276,
   "y": 413,
   "w": 24,
   "h": 19,
   "ax": 10.6,
   "ay": 8.2,
   "r": 0.51
  },
  "kenney-survival-kit/barrel": {
   "x": 302,
   "y": 413,
   "w": 31,
   "h": 32,
   "ax": 9.4,
   "ay": 22.3,
   "r": 0.35
  },
  "kenney-survival-kit/bucket": {
   "x": 335,
   "y": 413,
   "w": 17,
   "h": 18,
   "ax": 6.5,
   "ay": 11.6,
   "r": 0.2
  },
  "kenney-city-kit-roads/light-square@0": {
   "x": 354,
   "y": 413,
   "w": 137,
   "h": 220,
   "ax": 11.0,
   "ay": 208.1,
   "r": 1.6,
   "ppm": 48
  },
  "kenney-city-kit-roads/light-square@90": {
   "x": 493,
   "y": 413,
   "w": 196,
   "h": 152,
   "ax": 78.5,
   "ay": 140.6,
   "r": 1.6,
   "ppm": 48
  },
  "kenney-city-kit-roads/light-square@180": {
   "x": 691,
   "y": 413,
   "w": 137,
   "h": 163,
   "ax": 11.0,
   "ay": 132.5,
   "r": 1.6,
   "ppm": 48
  },
  "kenney-city-kit-roads/light-square@270": {
   "x": 830,
   "y": 413,
   "w": 204,
   "h": 152,
   "ax": 11.0,
   "ay": 140.6,
   "r": 1.6,
   "ppm": 48
  },
  "kenney-city-kit-roads/light-curved@0": {
   "x": 1036,
   "y": 413,
   "w": 151,
   "h": 231,
   "ax": 11.0,
   "ay": 219.8,
   "r": 1.51,
   "ppm": 48
  },
  "kenney-city-kit-roads/light-curved@90": {
   "x": 1189,
   "y": 413,
   "w": 193,
   "h": 168,
   "ax": 74.0,
   "ay": 156.8,
   "r": 1.51,
   "ppm": 48
  },
  "kenney-city-kit-roads/light-curved@180": {
   "x": 1384,
   "y": 413,
   "w": 151,
   "h": 154,
   "ax": 11.0,
   "ay": 134.8,
   "r": 1.51,
   "ppm": 48
  },
  "kenney-city-kit-roads/light-curved@270": {
   "x": 1537,
   "y": 413,
   "w": 214,
   "h": 168,
   "ax": 11.0,
   "ay": 156.8,
   "r": 1.51,
   "ppm": 48
  },
  "kenney-retro-urban-kit/detail-bench": {
   "x": 1753,
   "y": 413,
   "w": 54,
   "h": 30,
   "ax": 20.1,
   "ay": 18.9,
   "r": 0.86
  },
  "kenney-furniture-kit/trashcan": {
   "x": 1809,
   "y": 413,
   "w": 23,
   "h": 23,
   "ax": 6.5,
   "ay": 16.1,
   "r": 0.24
  },
  "kenney-retro-urban-kit/detail-dumpster-closed": {
   "x": 1834,
   "y": 413,
   "w": 58,
   "h": 44,
   "ax": 20.0,
   "ay": 29.1,
   "r": 0.98
  },
  "kenney-survival-kit/tent": {
   "x": 1894,
   "y": 413,
   "w": 41,
   "h": 54,
   "ax": 19.5,
   "ay": 36.3,
   "r": 0.98
  },
  "kenney-survival-kit/tent-canvas~2F6FB0": {
   "x": 1937,
   "y": 413,
   "w": 60,
   "h": 81,
   "ax": 28.9,
   "ay": 54.7,
   "r": 1.5
  },
  "oga-camping/tent~4A6B8A": {
   "x": 0,
   "y": 646,
   "w": 81,
   "h": 105,
   "ax": -2.5,
   "ay": 69.2,
   "r": 3.13
  },
  "kenney-survival-kit/structure-canvas~E8E0CC": {
   "x": 83,
   "y": 646,
   "w": 77,
   "h": 81,
   "ax": 26.0,
   "ay": 54.2,
   "r": 1.41
  },
  "kenney-food-kit/pot-stew": {
   "x": 162,
   "y": 646,
   "w": 24,
   "h": 26,
   "ax": 9.4,
   "ay": 15.8,
   "r": 0.14,
   "ppm": 64
  },
  "kenney-food-kit/cup-tea": {
   "x": 188,
   "y": 646,
   "w": 12,
   "h": 12,
   "ax": 4.6,
   "ay": 7.6,
   "r": 0.06,
   "ppm": 64
  },
  "oga-camping/Cauldron": {
   "x": 202,
   "y": 646,
   "w": 32,
   "h": 62,
   "ax": 10.5,
   "ay": 40.3,
   "r": 0.77
  },
  "oga-camping/camp_fire": {
   "x": 236,
   "y": 646,
   "w": 54,
   "h": 45,
   "ax": 30.9,
   "ay": 28.7,
   "r": 1.29
  },
  "kenney-furniture-kit/books": {
   "x": 292,
   "y": 646,
   "w": 12,
   "h": 11,
   "ax": 8.5,
   "ay": 4.4,
   "r": 0.32
  },
  "kenney-survival-kit/bedroll~5A6E8C": {
   "x": 306,
   "y": 646,
   "w": 27,
   "h": 44,
   "ax": 13.3,
   "ay": 22.6,
   "r": 0.82
  },
  "kenney-survival-kit/bottle-large": {
   "x": 335,
   "y": 646,
   "w": 25,
   "h": 28,
   "ax": 8.0,
   "ay": 18.5,
   "r": 0.11,
   "ppm": 64
  },
  "kenney-city-kit-roads/construction-cone": {
   "x": 362,
   "y": 646,
   "w": 22,
   "h": 23,
   "ax": 8.8,
   "ay": 14.0,
   "r": 0.35
  },
  "kenney-graveyard-kit/brick-wall@0": {
   "x": 386,
   "y": 646,
   "w": 171,
   "h": 89,
   "ax": 62.0,
   "ay": 111.0,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/brick-wall@90": {
   "x": 559,
   "y": 646,
   "w": 84,
   "h": 177,
   "ax": 62.0,
   "ay": 114.2,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/brick-wall@180": {
   "x": 645,
   "y": 646,
   "w": 171,
   "h": 89,
   "ax": 62.0,
   "ay": 27.0,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/brick-wall@270": {
   "x": 818,
   "y": 646,
   "w": 84,
   "h": 177,
   "ax": -22.0,
   "ay": 114.2,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/brick-wall-end@0": {
   "x": 904,
   "y": 646,
   "w": 171,
   "h": 120,
   "ax": 62.0,
   "ay": 132.2,
   "r": 2.19,
   "ppm": 40
  },
  "kenney-graveyard-kit/brick-wall-end@90": {
   "x": 1077,
   "y": 646,
   "w": 112,
   "h": 177,
   "ax": 71.0,
   "ay": 114.2,
   "r": 2.19,
   "ppm": 40
  },
  "kenney-graveyard-kit/brick-wall-end@180": {
   "x": 1191,
   "y": 646,
   "w": 178,
   "h": 120,
   "ax": 62.0,
   "ay": 48.2,
   "r": 2.19,
   "ppm": 40
  },
  "kenney-graveyard-kit/brick-wall-end@270": {
   "x": 1371,
   "y": 646,
   "w": 112,
   "h": 186,
   "ax": -13.0,
   "ay": 123.2,
   "r": 2.19,
   "ppm": 40
  },
  "kenney-graveyard-kit/brick-wall-curve@0": {
   "x": 1485,
   "y": 646,
   "w": 168,
   "h": 173,
   "ax": 62.0,
   "ay": 111.0,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/brick-wall-curve@90": {
   "x": 1655,
   "y": 646,
   "w": 171,
   "h": 173,
   "ax": 62.0,
   "ay": 111.0,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/brick-wall-curve@180": {
   "x": 1828,
   "y": 646,
   "w": 171,
   "h": 177,
   "ax": 62.0,
   "ay": 114.2,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/brick-wall-curve@270": {
   "x": 0,
   "y": 834,
   "w": 168,
   "h": 177,
   "ax": 62.0,
   "ay": 114.2,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/brick-wall-curve-small@0": {
   "x": 170,
   "y": 834,
   "w": 168,
   "h": 173,
   "ax": 62.0,
   "ay": 111.0,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/brick-wall-curve-small@90": {
   "x": 340,
   "y": 834,
   "w": 171,
   "h": 173,
   "ax": 62.0,
   "ay": 111.0,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/brick-wall-curve-small@180": {
   "x": 513,
   "y": 834,
   "w": 171,
   "h": 177,
   "ax": 62.0,
   "ay": 114.2,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/brick-wall-curve-small@270": {
   "x": 686,
   "y": 834,
   "w": 168,
   "h": 177,
   "ax": 62.0,
   "ay": 114.2,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/stone-wall@0": {
   "x": 856,
   "y": 834,
   "w": 171,
   "h": 77,
   "ax": 62.0,
   "ay": 111.0,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/stone-wall@90": {
   "x": 1029,
   "y": 834,
   "w": 72,
   "h": 177,
   "ax": 62.0,
   "ay": 114.2,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/stone-wall@180": {
   "x": 1103,
   "y": 834,
   "w": 171,
   "h": 77,
   "ax": 62.0,
   "ay": 15.0,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/stone-wall@270": {
   "x": 1276,
   "y": 834,
   "w": 72,
   "h": 177,
   "ax": -34.0,
   "ay": 114.2,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/stone-wall-column@0": {
   "x": 1350,
   "y": 834,
   "w": 171,
   "h": 108,
   "ax": 62.0,
   "ay": 132.2,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/stone-wall-column@90": {
   "x": 1523,
   "y": 834,
   "w": 100,
   "h": 177,
   "ax": 71.0,
   "ay": 114.2,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/stone-wall-column@180": {
   "x": 1625,
   "y": 834,
   "w": 171,
   "h": 108,
   "ax": 62.0,
   "ay": 36.2,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/stone-wall-column@270": {
   "x": 1798,
   "y": 834,
   "w": 100,
   "h": 177,
   "ax": -25.0,
   "ay": 114.2,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/stone-wall-curve@0": {
   "x": 0,
   "y": 1013,
   "w": 168,
   "h": 173,
   "ax": 62.0,
   "ay": 111.0,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/stone-wall-curve@90": {
   "x": 170,
   "y": 1013,
   "w": 171,
   "h": 173,
   "ax": 62.0,
   "ay": 111.0,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/stone-wall-curve@180": {
   "x": 343,
   "y": 1013,
   "w": 171,
   "h": 177,
   "ax": 62.0,
   "ay": 114.2,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/stone-wall-curve@270": {
   "x": 516,
   "y": 1013,
   "w": 168,
   "h": 177,
   "ax": 62.0,
   "ay": 114.2,
   "r": 2.12,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border@0": {
   "x": 686,
   "y": 1013,
   "w": 167,
   "h": 76,
   "ax": 62.0,
   "ay": 105.4,
   "r": 1.92,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border@90": {
   "x": 855,
   "y": 1013,
   "w": 70,
   "h": 174,
   "ax": 50.0,
   "ay": 111.6,
   "r": 1.92,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border@180": {
   "x": 927,
   "y": 1013,
   "w": 167,
   "h": 76,
   "ax": 62.0,
   "ay": 27.4,
   "r": 1.92,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border@270": {
   "x": 1096,
   "y": 1013,
   "w": 70,
   "h": 174,
   "ax": -28.0,
   "ay": 111.6,
   "r": 1.92,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border-column@0": {
   "x": 1168,
   "y": 1013,
   "w": 173,
   "h": 86,
   "ax": 62.0,
   "ay": 109.0,
   "r": 1.93,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border-column@90": {
   "x": 1343,
   "y": 1013,
   "w": 79,
   "h": 179,
   "ax": 54.3,
   "ay": 116.7,
   "r": 1.93,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border-column@180": {
   "x": 1424,
   "y": 1013,
   "w": 167,
   "h": 86,
   "ax": 62.0,
   "ay": 31.0,
   "r": 1.93,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border-column@270": {
   "x": 1593,
   "y": 1013,
   "w": 79,
   "h": 174,
   "ax": -23.7,
   "ay": 111.6,
   "r": 1.93,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border-curve@0": {
   "x": 1674,
   "y": 1013,
   "w": 150,
   "h": 166,
   "ax": 50.0,
   "ay": 103.3,
   "r": 1.92,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border-curve@90": {
   "x": 1826,
   "y": 1013,
   "w": 150,
   "h": 155,
   "ax": 50.0,
   "ay": 106.0,
   "r": 1.92,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border-curve@180": {
   "x": 0,
   "y": 1194,
   "w": 159,
   "h": 156,
   "ax": 62.0,
   "ay": 107.2,
   "r": 1.92,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border-curve@270": {
   "x": 161,
   "y": 1194,
   "w": 158,
   "h": 166,
   "ax": 62.0,
   "ay": 103.7,
   "r": 1.92,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border-gate@0": {
   "x": 321,
   "y": 1194,
   "w": 173,
   "h": 86,
   "ax": 62.0,
   "ay": 109.0,
   "r": 1.93,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border-gate@90": {
   "x": 496,
   "y": 1194,
   "w": 79,
   "h": 179,
   "ax": 54.3,
   "ay": 116.7,
   "r": 1.93,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border-gate@180": {
   "x": 577,
   "y": 1194,
   "w": 173,
   "h": 86,
   "ax": 62.0,
   "ay": 31.0,
   "r": 1.93,
   "ppm": 40
  },
  "kenney-graveyard-kit/iron-fence-border-gate@270": {
   "x": 752,
   "y": 1194,
   "w": 79,
   "h": 179,
   "ax": -23.7,
   "ay": 116.7,
   "r": 1.93,
   "ppm": 40
  },
  "kenney-graveyard-kit/fence@0": {
   "x": 833,
   "y": 1194,
   "w": 161,
   "h": 59,
   "ax": 62.0,
   "ay": 51.7,
   "r": 1.53,
   "ppm": 40
  },
  "kenney-graveyard-kit/fence@90": {
   "x": 996,
   "y": 1194,
   "w": 60,
   "h": 166,
   "ax": 13.0,
   "ay": 103.8,
   "r": 1.53,
   "ppm": 40
  },
  "kenney-graveyard-kit/fence-gate@0": {
   "x": 1058,
   "y": 1194,
   "w": 161,
   "h": 63,
   "ax": 62.0,
   "ay": 50.4,
   "r": 1.53,
   "ppm": 40
  },
  "kenney-graveyard-kit/fence-gate@90": {
   "x": 1221,
   "y": 1194,
   "w": 60,
   "h": 166,
   "ax": 14.2,
   "ay": 103.8,
   "r": 1.53,
   "ppm": 40
  },
  "kenney-city-kit-suburban/fence@0": {
   "x": 1283,
   "y": 1194,
   "w": 89,
   "h": 36,
   "ax": 35.2,
   "ay": 28.2,
   "r": 0.84,
   "ppm": 40
  },
  "kenney-city-kit-suburban/fence@90": {
   "x": 1374,
   "y": 1194,
   "w": 33,
   "h": 92,
   "ax": 7.3,
   "ay": 56.2,
   "r": 0.84,
   "ppm": 40
  },
  "kenney-building-kit/wall@0": {
   "x": 1409,
   "y": 1194,
   "w": 59,
   "h": 142,
   "ax": 4.0,
   "ay": 99.6,
   "r": 1.0,
   "ppm": 40
  },
  "kenney-building-kit/wall@90": {
   "x": 1470,
   "y": 1194,
   "w": 135,
   "h": 66,
   "ax": 42.0,
   "ay": 61.6,
   "r": 1.0,
   "ppm": 40
  },
  "kenney-building-kit/wall-window-wide-square@0": {
   "x": 1607,
   "y": 1194,
   "w": 61,
   "h": 222,
   "ax": 6.0,
   "ay": 139.6,
   "r": 2.0,
   "ppm": 40
  },
  "kenney-building-kit/wall-window-wide-square@90": {
   "x": 1670,
   "y": 1194,
   "w": 215,
   "h": 66,
   "ax": 82.0,
   "ay": 61.6,
   "r": 2.0,
   "ppm": 40
  },
  "kenney-prototype-kit/wall@0": {
   "x": 1887,
   "y": 1194,
   "w": 75,
   "h": 158,
   "ax": 11.6,
   "ay": 107.6,
   "r": 1.22,
   "ppm": 40
  },
  "kenney-prototype-kit/wall@90": {
   "x": 0,
   "y": 1418,
   "w": 151,
   "h": 81,
   "ax": 50.0,
   "ay": 69.2,
   "r": 1.22,
   "ppm": 40
  },
  "kenney-prototype-kit/wall-window-barred-small@0": {
   "x": 153,
   "y": 1418,
   "w": 79,
   "h": 158,
   "ax": 16.4,
   "ay": 107.6,
   "r": 1.22,
   "ppm": 40
  },
  "kenney-prototype-kit/wall-window-barred-small@90": {
   "x": 234,
   "y": 1418,
   "w": 151,
   "h": 82,
   "ax": 50.0,
   "ay": 69.2,
   "r": 1.22,
   "ppm": 40
  },
  "kenney-prototype-kit/wall-window-barred-medium@0": {
   "x": 387,
   "y": 1418,
   "w": 79,
   "h": 158,
   "ax": 16.4,
   "ay": 107.6,
   "r": 1.22,
   "ppm": 40
  },
  "kenney-prototype-kit/wall-window-barred-medium@90": {
   "x": 468,
   "y": 1418,
   "w": 151,
   "h": 84,
   "ax": 50.0,
   "ay": 69.2,
   "r": 1.22,
   "ppm": 40
  },
  "kenney-prototype-kit/wall-window-barred-large@0": {
   "x": 621,
   "y": 1418,
   "w": 79,
   "h": 158,
   "ax": 16.4,
   "ay": 107.6,
   "r": 1.22,
   "ppm": 40
  },
  "kenney-prototype-kit/wall-window-barred-large@90": {
   "x": 702,
   "y": 1418,
   "w": 151,
   "h": 84,
   "ax": 50.0,
   "ay": 69.2,
   "r": 1.22,
   "ppm": 40
  },
  "kenney-prototype-kit/door-sliding-double@0": {
   "x": 855,
   "y": 1418,
   "w": 67,
   "h": 137,
   "ax": 18.8,
   "ay": 91.3,
   "r": 1.09,
   "ppm": 40
  },
  "kenney-prototype-kit/door-sliding-double@90": {
   "x": 924,
   "y": 1418,
   "w": 132,
   "h": 67,
   "ax": 45.2,
   "ay": 52.9,
   "r": 1.09,
   "ppm": 40
  },
  "kenney-prototype-kit/door-sliding-double-wide@0": {
   "x": 1058,
   "y": 1418,
   "w": 67,
   "h": 185,
   "ax": 18.8,
   "ay": 115.3,
   "r": 1.68,
   "ppm": 40
  },
  "kenney-prototype-kit/door-sliding-double-wide@90": {
   "x": 1127,
   "y": 1418,
   "w": 180,
   "h": 67,
   "ax": 69.2,
   "ay": 52.9,
   "r": 1.68,
   "ppm": 40
  },
  "kenney-building-kit/column": {
   "x": 1309,
   "y": 1418,
   "w": 73,
   "h": 80,
   "ax": 12.0,
   "ay": 67.6,
   "r": 0.32,
   "ppm": 40
  },
  "kenney-prototype-kit/column": {
   "x": 1384,
   "y": 1418,
   "w": 75,
   "h": 81,
   "ax": 11.6,
   "ay": 69.2,
   "r": 0.34,
   "ppm": 40
  },
  "metro_gate_open@90": {
   "x": 1461,
   "y": 1418,
   "w": 231,
   "h": 169,
   "ax": 92.0,
   "ay": 110.0,
   "r": 4.59
  },
  "metro_gate_open@180": {
   "x": 1694,
   "y": 1418,
   "w": 167,
   "h": 238,
   "ax": 62.5,
   "ay": 145.5,
   "r": 4.59
  },
  "metro_gate_open@270": {
   "x": 0,
   "y": 1658,
   "w": 227,
   "h": 169,
   "ax": 94.2,
   "ay": 110.0,
   "r": 4.59
  }
 }
}
